<template>
  <m-base
    :showTopBorder="pattern.showTopBorder"
    :showRightBorder="pattern.showRightBorder"
    :showBottomBorder="pattern.showBottomBorder"
    :showLeftBorder="pattern.showLeftBorder"
    :showHeader="false"
    :showPadding="false"
    :showLeftPadding="pattern.showLeftPadding"
    :showRightPadding="pattern.showRightPadding"
    :showTopPadding="pattern.showTopPadding"
    :showBottomPadding="pattern.showBottomPadding"
    :showBorderRadius="pattern.showBorderRadius"
    :backgroundColor="pattern.backgroundColor"
    :boxType="pattern.boxType"
  >
    <div slot="content">
      <div
        :class="{
        'cate-section-flex-row':pattern.showType == 'flex-row',
        'cate-section-scroll':pattern.showType == 'scroll'
        }"
      >
        <div
          v-for="(item,index) in myData"
          :key="index"
          :style="{
            width:(100 / pattern.num )+'%',
            display:pattern.showType == 'scroll'?'inline-block':'block'}"
        >
          <div
            class="cate-item"
            :style="{
              marginTop:pattern.showType == 'flex-row'&&index>= pattern.num?'10px':'0px',
              marginLeft:pattern.showType == 'scroll'&&pattern.imgType == 'big'?'5px':'0px',
              marginRight:pattern.showType == 'scroll'&&pattern.imgType == 'big'?'5px':'0px'
            }"
            @click="navToDetailPage(item,index)"
          >
            <van-image lazy-load
              fit="contain"
              :class="{
                circleImg:pattern.circle ,
                'cate-item-img-big':pattern.imgType=='big',
                'cate-item-img-small':pattern.imgType=='small'
                }"
              :src="item.src"
            />
            <span
              style="margin-top:7px"
              v-if="item.name"
              :style="{color:pattern.titleColor}"
            >{{item.name}}</span>
          </div>
        </div>
      </div>
    </div>
  </m-base>
</template>

<script>
export default {
  props: {
    params: {
      type: Object,
      default: () => { }
    },
    data: {
      type: Array,
      default: () => []
    },
    pattern: {
      type: Object,
      default: () => {
        return {
          showTopBorder: false,
          showRightBorder: false,
          showBottomBorder: true,
          showLeftBorder: false,
          showBorderRadius: false,
          showLeftPadding: true,
          showRightPadding: true,
          showTopPadding: true,
          showBottomPadding: true,
          backgroundColor: 'rgba(255,255,255,1)',
          titleColor: 'rgba(0,0,0,1)',
          boxType: 'block',
          showType: 'flex-row',
          circle: true,
          imgType: 'small',
          num: 5
        }
      }
    },
  },
  data () {
    return {
      myData: this.data,
      defaultPattern: {
        showTopBorder: false,
        showRightBorder: false,
        showBottomBorder: true,
        showLeftBorder: false,
        showBorderRadius: false,
        showLeftPadding: true,
        showRightPadding: true,
        showTopPadding: true,
        showBottomPadding: true,
        backgroundColor: 'rgba(255,255,255,1)',
        boxType: 'block',
        showType: 'flex-row',
        circle: true,
        imgType: 'small',
        num: 5
      },
    };
  },
  mounted () {
    if (this.data.length == 0) {
      this.defaultDataList()
    }
  },
  created () {

  },
  methods: {
    defaultDataList () {
      this.myData = [{
        src: require('@/static/temp/c1.png'),
        name: '课程分类',
        navTo: '/onlinePages/category/category'
      },
      {
        src: require('@/static/temp/c2.png'),
        name: '商城分类',
        navTo: '/pages/category/category'
      },
      {
        src: require('@/static/temp/c3.png'),
        name: '直播',
        navTo: '/pages/live/list'
      },
      {
        src: require('@/static/temp/c4.png'),
        name: '导航',
        navTo: ''
      },
      {
        src: require('@/static/temp/c5.png'),
        name: '导航',
        navTo: ''
      },
      {
        src: require('@/static/temp/c6.png'),
        name: '导航',
        navTo: ''
      }
      ]
    },
    navToDetailPage (item, index) {
      let navTo = item.navTo
      if (navTo) {
        if (navTo.indexOf('http') > -1) {
          window.location.href = navTo
        } else {
          this.$router.push(this.$uitl.getPathQuery(navTo))
        }
      }
    },
  },
  watch: {
    data: {
      deep: true,
      handler: function (newVal) {
        this.myData = newVal
      }
    },
    pattern: {
      deep: true,
      handler: function (newVal) {
        // this.myData = newVal
        // console.log(newVal)
      }
    }
  }
}
</script>

<style lang="scss" scoped>
/* 分类 */
.cate-section-flex-row {
  display: flex;
  justify-content: flex-start;
  align-items: center;
  flex-wrap: wrap;
}
.cate-section-scroll {
  white-space: nowrap;
  overflow-x: scroll;
  overflow-y: hidden;
}
.cate-item {
  height: 100%;
  display: flex;
  flex-direction: column;
  align-items: center;
  font-size: $uni-font-size-sm + 1px;
  color: $font-color-dark;
}

.cate-item-img-big {
  width: 100%;
}
.cate-item-img-big img {
  width: 100%;
  // width: 44px;
  // height: 60px;
}
.cate-item-img-small {
  width: 44px;
  height: 44px;
}

.circleImg {
  border-radius: 50%;
  overflow: hidden;
}

.margin-top {
  margin-top: 10px;
}
.margin-right {
  margin-right: 10px;
}
</style>
